import { useCallback } from 'react';
import { useIntl } from 'react-intl';

/** Anything that can produce a JS Date — covers Dayjs (.toDate()) without naming it. */
interface DateLike {
  toDate(): Date;
}

export const useFormat = (yesLabel: string, noLabel: string) => {
  const { locale, formatNumber: intlFormatNumber } = useIntl();

  const formatDateTime = useCallback(
    (value: Date | DateLike) => {
      const date = value instanceof Date ? value : value.toDate();

      const formattedDate = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date);

      const formattedTime = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);

      return `${formattedDate} ${formattedTime}`;
    },
    [locale],
  );

  const formatNumber = useCallback(
    (value: number, isInteger?: boolean) =>
      intlFormatNumber(value, {
        minimumFractionDigits: isInteger ? 0 : 2,
        maximumFractionDigits: 2,
      }),
    [intlFormatNumber],
  );

  const formatBoolean = (value: boolean) => (value ? yesLabel : noLabel);

  return { formatDateTime, formatNumber, formatBoolean };
};
